import React from "react";
import { Helmet } from "react-helmet-async";
import contact from "../utils/db/contactInfo";
import { getRoute } from "../utils/helper";

const ContactUs = () => {
  return (
    <div className="ContactUs">
      <Helmet>
        <title>{getRoute("contact-us")?.name}</title>
      </Helmet>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <h4 className="page-title">İletişim</h4>
          </div>
        </div>
        <div className="row">
          {contact.map((data) => (
            <div key={data.id} className="col-12 col-lg-6">
              <div className="row">
                <div className="col">
                  <h5 className="title">{data.title}</h5>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <p className="address">{data.address}</p>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="email d-flex justify-content-start align-items-center">
                    <div className="icon">
                      <svg width="42px" height="42px" viewBox="0 0 42 42">
                        <g
                          id="Page-1"
                          stroke="none"
                          strokeWidth="1"
                          fill="none"
                          fillRule="evenodd"
                        >
                          <g
                            id="İletişim"
                            transform="translate(-135.000000, -422.000000)"
                          >
                            <g
                              id="Group-15"
                              transform="translate(136.000000, 316.000000)"
                            >
                              <g
                                id="Group-2"
                                transform="translate(0.000000, 107.000000)"
                              >
                                <circle
                                  id="Oval"
                                  stroke="#000000"
                                  cx="20"
                                  cy="20"
                                  r="20"
                                ></circle>
                                <path
                                  d="M30.5834234,14.499103 C28.5950868,16.4608171 26.5863253,18.4426272 24.5680324,20.433875 C26.5845881,22.4263906 28.593819,24.4116753 30.5834234,26.3775682 L30.5834234,14.499103 Z M9.4210454,14.4626202 L9.4210454,26.3383151 C11.395296,24.3890907 13.4072972,22.4026321 15.4313185,20.4042944 C13.4229327,18.4188688 11.416519,16.4353214 9.4210454,14.4626202 L9.4210454,14.4626202 Z M29.5368786,27.4472611 C27.5066125,25.4391101 25.5084625,23.4626996 23.5105474,21.4865239 C22.8998242,22.0937725 22.2627131,22.7254839 21.6276211,23.3591673 C20.6839981,24.3007243 19.3136624,24.3001139 18.3710724,23.3559745 C17.7920898,22.7760058 17.2134827,22.1956614 16.6341244,21.6160684 C16.5754796,21.5574235 16.5129376,21.5027228 16.4522268,21.4461909 C16.4741541,21.477274 16.4960344,21.5083572 16.5179616,21.5394404 C14.5195769,23.5108738 12.5212392,25.4823072 10.5294279,27.4472611 L29.5368786,27.4472611 Z M29.5360803,13.4744384 C29.5254219,13.4573004 29.5148104,13.4402094 29.504199,13.4230714 L10.4742577,13.4230714 C10.5462373,13.501108 10.5997642,13.5631334 10.6574699,13.621027 C13.5521486,16.5228895 16.447062,19.4245173 19.342304,22.3258633 C19.7823985,22.7669437 20.2198635,22.7655351 20.6636204,22.3210271 C23.0575407,19.9231157 25.4497238,17.523467 27.8456632,15.1275276 C28.4029064,14.5702844 28.9722636,14.0251551 29.5360803,13.4744384 L29.5360803,13.4744384 Z M30.2187831,28.8564743 L9.78122512,28.8564743 C9.73117277,28.8389606 9.68205949,28.8178785 9.63088025,28.8045438 C8.94005452,28.6250878 8.44718442,28.2103012 8.16020509,27.5583999 C8.09235739,27.4042987 8.05263479,27.2378958 8,27.0771273 C8,22.6443953 8,18.2116633 8,13.7789314 C8.017138,13.7281278 8.03822009,13.6782632 8.05080361,13.6263327 C8.28068757,12.6772162 9.11678721,12.001979 10.0855303,12.0016973 C16.694037,11.9995844 23.3024967,11.9992557 29.9109565,12.0017912 C31.0628179,12.0022607 31.9967685,12.9352722 31.9977075,14.0864763 C32.0010412,18.3157121 32.0004308,22.544948 31.9978484,26.7741838 C31.997285,27.6826856 31.3956707,28.485777 30.527361,28.7601728 C30.424627,28.7926176 30.3216581,28.8243581 30.2187831,28.8564743 L30.2187831,28.8564743 Z"
                                  id="Fill-1"
                                  fill="#000000"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                    <a href={`mailto:${data.email}`}>{data.email}</a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
